import ReportPageExport from "./report-page" ;

export default ReportPageExport 